module.exports = __webpack_public_path__ + "img/b0309_9.9e6f2f17.png";